import React from 'react';

import { DiscordFillBrand } from 'lib/lucky-x-icons-2';
import { useRouter } from 'next/router';

interface ILaunchWithLuckyProps {}

const LaunchWithLucky: React.FC<ILaunchWithLuckyProps> = ({}) => {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-xl bg-neutral-900 px-6 py-8 lg:flex-row lg:justify-between">
      <div className="flex flex-col items-center justify-center gap-1 whitespace-pre-line text-2xl font-extrabold lg:flex-row lg:justify-start lg:gap-1">
        <div className="text-center !text-white lg:text-left">
          🚀 Launch your Ordinals with LuckyGo.
        </div>
        <div className="text-center text-app lg:text-left">
          All free for creators!
        </div>
      </div>
      <div className="flex flex-col-reverse items-center justify-center gap-3 md:flex-row ">
        <div
          className="text-base font-normal !text-white underline cursor-pointer hover:!text-neutral-400"
          onClick={() => {
            router.push('/launchwithlucky');
          }}
        >
          Learn More
        </div>
        <div
          className=" flex cursor-pointer items-center justify-center gap-1 rounded-3xl bg-[#5865F2] px-6 py-3 text-white hover:bg-opacity-90 "
          onClick={() => {
            open('https://discord.gg/Gykdc8PNwv');
          }}
        >
          <div className="text-sm font-medium ">Submit on Discord</div>
          <DiscordFillBrand size={24} />
        </div>
      </div>
    </div>
  );
};

export default LaunchWithLucky;
